export default __webpack_public_path__ + "static/media/body_egyptianmummy.d675fc33.png";